import React, { useState } from "react"

import { useImage } from "../../../hooks/useImage"

export const withCallToAction = Component => ({ name = "CallToAction", content, theme: rawTheme, title, video: rawVideo, additionalPlayButton }) => {
  const { getResponsiveImage } = useImage()
  const [play, setPlay] = useState(false)
  const [played, setPlayed] = useState(false)

  const video = rawVideo?.asset && {
    ...rawVideo,
    poster: getResponsiveImage(rawVideo?.poster, { maxWidth: 2000 }),
  }
  const theme = video?.asset ? `dark` : rawTheme?.toLowerCase()

  const handlePlayed = () => {
    setPlayed(prevState => !prevState)
  }

  const handleVideo = (state: boolean) => {
    setPlay(state)
    !played && setPlayed(true)
  }

  Component.displayName = name
  return (
    <Component
      title={title}
      content={content}
      play={play}
      played={played}
      theme={theme}
      video={video}
      additionalPlayButton={additionalPlayButton}
      handlePlayed={handlePlayed}
      handleVideo={handleVideo}
    />
  )
}
